<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Before Sign In Notes</v-card-title>
        <v-card-text>

            <div
                v-for="(item, index) in ack_notes"
                :key="index"
            >

                <b>{{item.subject}}</b>
                <m-showdown
                    :value="item.body"
                />

                <v-switch
                    label="Understood"
                    v-model="item.ack"
                />

            </div>

        </v-card-text>
        
        <v-card-actions>

            <v-spacer/>

            <v-btn
                text
                v-on:click="onClickCancel"
            >
                Cancel
            </v-btn>

            <v-btn
                text
                color="primary"
                :disabled="!is_valid"
                v-on:click="completeSignInAs"
            >
                Sign In
            </v-btn>
    
    </v-card-actions>

    </v-card>

</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,

            sign_in_as_employee_id: null,
            sign_in_as_organization_id: null,
            after_route: null,

            ack_notes: [],
        }
    },

    created () {
        this.$event_bus.$on('sign-in-as', this.onSignInAs);
    },

    beforeDestroy () {
        this.$event_bus.$off('sign-in-as',this.onSignInAs);
    },

    methods: {

        onSignInAs(params)
        {
            params = _.cloneDeep(params);
            
            if ( params.employee_id == 'any-org-admin' )
            {
                
                this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'GET: /api/v1/employees/any-org-admin/:organization_id',
                
                    'params' : {
                            'organization_id': params.organization_id,
                        },
                
                    'on_success': (data) => {
                            if ( data.employee_id != null )
                            {
                                params.employee_id = data.employee_id;
                                this.onSignInAsAfterResolveEmployeeId(params);
                            }
                            else
                            {
                                this.$rc.alert('No organization admin', 'This organization does have an organization administrator.  Create one and try again.');
                                return;
                            }
                        },
                
                    'on_error': 'Unable to find any organization admin',
                });

            }
            else
            {
                this.onSignInAsAfterResolveEmployeeId(params);
            }
        },

        onSignInAsAfterResolveEmployeeId(params)
        {
            this.dialog = false;
            this.ack_notes = [];
            this.sign_in_as_employee_id = params.employee_id;
            this.sign_in_as_organization_id = params.organization_id;
            this.after_route = _.cloneDeep(params.after_route);

            if ( this.$rc.$state.isAuthActorSystemAdmin() )
            {
                this.checkForAckNotes();
            }
            else
            {
                this.completeSignInAs();
            }
        },

        completeSignInAs()
        {
            window.open(this.$router.resolve({
                'name': 'home-complete-sign-in-as',
                'params' : {
                    'employee_id': this.sign_in_as_employee_id,
                },
                'query': {
                    'after_route': this.after_route == null ? null : JSON.stringify(this.after_route),
                },
            }).href, '_blank');
        },

        checkForAckNotes()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/red-chirp-crm/notes',
            
                'params' : {
                        'organization_id': this.sign_in_as_organization_id,
                        'is_archived': false,
                        'ack_before_access': true,
                    },
            
                'on_success': (data) => {

                        if ( data.results.length == 0 )
                        {
                            this.completeSignInAs();
                            return;
                        }

                        this.ack_notes = data.results
                            .map((item) => { item.ack = false; return item; });

                        this.dialog = true;
                    },
            
                'on_error': () => { this.completeSignInAs(); },
            });
        },

        onClickCancel()
        {
            this.dialog = false;
        },
    },

    computed: {
        is_valid() {
            return !this.ack_notes.some((item) => !item.ack);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>